import React from "react"
import { DebugAtoms } from "@digits-shared/atoms/DebugAtoms"
import { ScopeProvider } from "bunshi/react"

export const ScopeProviderWithDebugAtoms: React.FC<React.ComponentProps<typeof ScopeProvider>> = ({
  children,
  ...rest
}) => (
  <ScopeProvider {...rest}>
    <DebugAtoms />
    {children}
  </ScopeProvider>
)
